module.exports = __webpack_public_path__ + "static/media/Innovative Teaching Learning on DSM 2024.e4c6280b.pdf";